<template>

    <div class="is-100-width">
        <div class="is-pushed-center gift-card-wrapper">

            <div :class="'card ' + (kioskMode ? '' : 'is-hidden-mobile')">
                <div class="card-image has-grey-light-border">
                    <figure class="image is-16by9">
                        <img :src=" $store.state.assetRoute + '/images/gift-card-image.jpg' " alt="Gift Card Header">
                    </figure>
                </div>
            </div>
            <div v-if=" !kioskMode " class="card is-hidden-tablet">
                <div class="card-image has-grey-light-border">
                    <figure class="image is-16by9">
                        <img :src=" $store.state.assetRoute + '/images/gift-card-image.jpg' " alt="Gift Card Header">
                    </figure>
                </div>
            </div>

            <div class="card has-background-grey-dark gift-card-inner-wrapper" style="border-top-left-radius: initial;border-top-right-radius: initial;">

                <div v-if=" type === 'both' " class="columns is-mobile m-0">
                    <div :class="'column is-half digitalOrPhysicalButton l ' + (digitalOrPhysical === 'digital' ? 'selected' : '') " @click=" () => {digitalOrPhysical = 'digital'} ">eGift Card <p>Emailed or Printed</p></div>
                    <div :class="'column is-half digitalOrPhysicalButton r ' + (digitalOrPhysical === 'physical' ? 'selected' : '') " @click=" () => {digitalOrPhysical = 'physical'} ">Gift Card <p>Purchased at Xerocraft</p></div>
                </div>


                <div :class="'card-content p-0 is-100-width has-text-white ' + (kioskMode ? '' : 'is-hidden-mobile')">

                    <template v-if=" type !== 'physical' && digitalOrPhysical === 'digital' ">
                        <h3 class="px-5 title is-3 mt-4 mb-0 has-text-white has-text-centered">Purchase eGift Card</h3>
                    </template>
                    <template v-if=" type !== 'digital' && digitalOrPhysical === 'physical' ">
                        <h3 class="px-5 title is-3 mt-4 mb-0 has-text-white has-text-centered">Purchase Gift Card</h3>

                        <div class="p-5">
                            <label :for=" 'code'+_uid " class="label has-text-white">Provide the Gift Card's Code</label>
                            <div class="field has-addons">
                                <div class="control has-icons-left is-expanded">
                                    <xero-input name="code" v-model="code" :class="'input '+(codeSuccess ? 'is-success' : '')" :uppercase="true" />
                                    <span class="icon is-small is-left"><i class="fas fa-tag"></i></span>
                                </div>
                                <button type="button" class="button" @click=" () => {$modal.show('qr-code-reader')} " aria-label="QR Code Reader Option">
                                    <span class="icon"><img :src=" $store.state.assetRoute + '/images/QR-Code-Reader-Icon.png' " alt="QR Code Reader Icon"></span>
                                    &nbsp; SCAN
                                </button>
                            </div>
                            <p class="help">If you're buying one of our plastic gift cards, then you can find this code on the back of the gift card.</p>
                            <p class="help">If you're making your own custom gift card, then put your unique code here to check if it's available and to activate it.</p>
                        </div>
                    </template>

                    <template v-if="sizes.length > 0">

                        <div v-for="size in sizes" class="p-5 gift-card-inner">
                            <div class="level is-mobile">
                                <div class="level-left">
                                    <div class="level-item has-text-left">
                                        <p>$ {{ size }} gift card</p>
                                    </div>
                                </div>
                                <div class="level-right">
                                    <div class="level-item has-text-right">
                                        <p>$ {{ size }}</p>
                                    </div>
                                    <div class="level-item">
                                        <button class="button is-primary" type="button" @click.prevent=" () => {chosenSize = size; startOrder();} ">{{ digitalOrPhysical === 'digital' ? 'Buy' : 'Activate' }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </template>


                    <template v-if=" showCustom ">

                        <div class="p-5">
                            <div class="level is-mobile">
                                <div class="level-left">
                                    <div class="level-item has-text-left">
                                        <p>Custom amount...</p>
                                    </div>
                                </div>
                                <div class="level-right">
                                    <div class="level-item has-text-right">
                                        <div class="field has-addons">
                                            <div class="control has-icons-left">
                                                <input type="number" style="width:7em;" :id="'custom_gift_card_' + _uid" class="input" name="size" min="1" step="1" v-model=" chosenSize "/>
                                                <span class="icon is-small is-left">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                            <div class="control">
                                                <button @click=" startOrder " class="button is-primary" type="button">{{ digitalOrPhysical === 'digital' ? 'Buy' : 'Activate' }}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </template>

                    <div class="has-background-dark p-5 gift-card-bottom has-text-centered">
                        <p>You can also purcahse Memberships or Tickets (for classes or events) for other people as well! Try visiting the membership page or view our classes/events to learn more!</p>
                    </div>

                </div>


                <div v-if=" !kioskMode " class="card-content p-0 is-100-width has-text-white is-hidden-tablet">

                    <template v-if=" type !== 'physical' && digitalOrPhysical === 'digital' ">
                        <h4 class="title is-4 mt-2 mb-0 has-text-white has-text-centered">Purchase eGift Card</h4>
                    </template>
                    <template v-if=" type !== 'digital' && digitalOrPhysical === 'physical' ">
                        <h4 class="title is-4 mt-2 mb-0 has-text-white has-text-centered">Purchase Gift Card</h4>

                        <div class="p-5">
                            <label :for=" 'code'+_uid " class="label has-text-white">Provide the Gift Card's Code</label>
                            <div class="field has-addons">
                                <div class="control has-icons-left ">
                                    <xero-input name="code" v-model="code" class="input" :uppercase="true" />
                                    <span class="icon is-small is-left"><i class="fas fa-tag"></i></span>
                                </div>
                                <div class="control">
                                    <button type="button" class="button" @click=" () => {$modal.show('qr-code-reader')} " aria-label="QR Code Reader Option">
                                        <span class="icon"><img :src=" $store.state.assetRoute + '/images/QR-Code-Reader-Icon.png' " alt="QR Code Reader Icon"></span>
                                        &nbsp; SCAN
                                    </button>
                                </div>
                            </div>
                            <p class="help">If you're buying one of our plastic gift cards, then you can find this code on the back of the gift card.</p>
                            <p class="help">If you're making your own custom gift card, then put your unique code here to check if it's available and to activate it.</p>
                        </div>
                    </template>

                    <template v-if="sizes.length > 0">

                        <div v-for="size in sizes" class="p-5 gift-card-inner">
                            <div class="level is-mobile">
                                <div class="level-left can-shrink">
                                    <div class="level-item has-text-left">
                                        <p>$ {{ size }} gift card</p>
                                    </div>
                                </div>
                                <div class="level-right">
                                    <div class="level-item">
                                        <button class="button is-primary" type="button" @click.prevent=" () => {chosenSize = size; startOrder();} ">Buy</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </template>


                    <template v-if=" showCustom ">

                        <div class="p-5">
                            <div class="level is-mobile">
                                <div class="level-left">
                                    <div class="level-item has-text-left">
                                        <p>Custom</p>
                                    </div>
                                </div>
                                <div class="level-right">
                                    <div class="level-item has-text-right">
                                        <div class="field has-addons">
                                            <div class="control has-icons-left">
                                                <input type="number" style="width:7em;" :id="'custom_gift_card_' + _uid" class="input" name="size" min="1" step="1" v-model=" chosenSize "/>
                                                <span class="icon is-small is-left">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                            <div class="control">
                                                <button @click=" startOrder " class="button is-primary" type="button">Buy</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </template>

                    <div class="has-background-dark p-5 gift-card-bottom has-text-centered">
                        <p>You can also purcahse Memberships or Tickets (for classes or events) for other people as well! Try visiting the membership page or view our classes/events to learn more!</p>
                    </div>

                </div>

            </div>


            <modal
                name="qr-code-reader"
                :adaptive="true"
                :width="'90%'"
                :height="'auto'">
                <div class="p-2 has-text-dark">
                    <button type="button" class="delete" aria-label="close qr code reader window" @click=" () => {$modal.hide('qr-code-reader')} "></button>
                    <h3 class="title is-3 has-text-dark has-text-centered">Scan Gift Card QR Code</h3>
                </div>

                <qrcode-stream @decode=" onQRDecode "></qrcode-stream>
            </modal>

            <modal
                :name="'gift-card-modal_' + _uid"
                :adaptive="true"
                :scrollable="true"
                :width="'90%'"
                :max-width="900"
                :height="'auto'"
                @closed=" closeOrder "
            >
                <div class="container is-padded has-text-black">
                    <button type="button" class="delete is-top-right mt-1 mr-1" aria-label="Close" @click=" $modal.hide('gift-card-modal_' + _uid) ">Close</button>

                    <div>
                        <h3 class="title is-3">Order Details</h3>
                        <p class="help is-primary">Checkout Progress</p>
                        <progress class="progress is-primary" :value=" progress " max="100">{{ progress }}%</progress>
                    </div>


                    <div v-if=" $isEmptyObject(xUser) " class="has-margins">

                        <div class="is-divider"></div>

                        <login-or-guest
                            :route-inline-login=" routeInlineLogin "
                            :route-guest-setup=" routeGuestSetup "
                            @login=" loggedIn "
                            @guest=" guestCheckout "
                            :kiosk-mode="kioskMode"
                        ></login-or-guest>

                    </div>

                    <div v-if=" !$isEmptyObject(xUser) && !$isEmptyObject(order) " class="columns my-4">


                        <div class="column is-one-third is-hidden-tablet">

                            <div class="card">
                                <div class="card-header">
                                    <p class="card-header-title"><i class="fas fa-shopping-cart"></i> &nbsp; Order Summary</p>
                                </div>
                                <div class="card-content">
                                    <ul>
                                        <li class="level is-mobile">
                                            <p class="level-left can-shrink">
                                                <span v-if=" quantity > 1 ">$ {{ chosenSize }} Gift Cards x {{ quantity }}</span>
                                                <span v-else>$ {{ chosenSize }} Gift Card</span>
                                            </p>
                                            <p class="level-right">
                                                <span class="has-text-weight-bold" >$ {{ orderTotal() }}</span>
                                            </p>
                                        </li>
                                    </ul>


                                    <template v-if=" !$isEmptyObject(xDiscountCodes) ">
                                        <div class="level is-mobile has-margins-05 has-margins-tb is-padded-05 is-padded-tb has-top-border has-no-bottom-margin has-no-bottom-margin">
                                            <p class="level-left">
                                                <span class="has-text-weight-bold level is-mobile has-margins-05 has-margins-tb is-padded-05 is-padded-tb">Sub-Total:</span>
                                            </p>
                                            <p class="level-right">
                                                <span class="has-text-weight-bold">$ {{ orderTotal() }}</span>
                                            </p>

                                        </div>

                                        <div class="level is-mobile">
                                            <p class="level-left">
                                                <span class="has-text-weight-bold">Discounts:</span>
                                            </p>
                                            <p class="level-right">
                                                <span class="has-text-weight-bold has-text-success">- $ {{ totalDiscounts }}</span>
                                            </p>
                                        </div>
                                    </template>

                                    <div class="level is-mobile has-margins-05 has-margins-tb is-padded-05 is-padded-tb has-top-border">
                                        <p class="level-left">
                                            <span class="has-text-weight-bold">Order Total:</span>
                                        </p>

                                        <p class="level-right">
                                            <span class="has-text-weight-bold">{{ (finalOrderTotal() === 0 ? 'Free' : '$ ' + finalOrderTotal()) }}</span>
                                        </p>
                                    </div>


                                </div>
                            </div>


                            <div v-if="step === 1 && order.undiscounted_amount > 0 " class="card mt-4">
                                <div class="card-header">
                                    <p class="card-header-title"><i class="fas fa-tags"></i> &nbsp; Discount Code</p>
                                </div>
                                <div class="card-content">

                                    <discount-code
                                        @loading="(data) => {loading = data;}"
                                        @discount-codes="(discountCodes) => {xDiscountCodes = discountCodes}"
                                        @order="(o) => {order = o}"
                                        :existing-discounts =" xDiscountCodes "
                                        :route-add="routeAddDiscountCodes"
                                        :route-remove="routeRemoveDiscountCodes"
                                        :order-id="order.id"
                                    ></discount-code>

                                </div>
                            </div>


                        </div>


                        <div class="column is-two-thirds" v-if=" step === 0 ">

                            <template v-if=" digitalOrPhysical === 'digital' ">

                                <div class="card">
                                    <div class="card-header">
                                        <p class="card-header-title">Gift Card Information</p>
                                    </div>
                                    <div class="card-content">

                                        <div class="field is-horizontal">
                                            <div class="field-label">
                                                <label for="quantity" class="label required">Quantity</label>
                                            </div>
                                            <div class="field-body">
                                                <div class="field">
                                                    <div class="control has-icons-left is-expanded">
                                                        <div class="select is-fullwidth">
                                                            <select id="quantity" name="quantity" class="" v-model="quantity">
                                                                <option v-for=" n in 10 " :value="n">{{ n }}</option>
                                                            </select>
                                                        </div>
                                                        <div class="icon is-small is-left">
                                                            <i class="fas fa-hashtag"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="field is-horizontal">
                                            <div class="field-label">
                                                <label for="from" class="label required">From</label>
                                            </div>
                                            <div class="field-body">
                                                <div class="field">
                                                    <p class="control is-expanded has-icons-left">
                                                        <input type="text" class="input" id="from" @focus=" checkCompleted " @blur=" checkCompleted "
                                                               v-model="from" placeholder="Your Name, first name, nickname, etc." required>
                                                        <span class="icon is-left"><i class="fas fa-user"></i></span>
                                                    </p>
                                                    <p class="help">NOTE: This is the name that will appear on the gift card as the purchaser.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="field is-horizontal">
                                            <div class="field-label">
                                                <label for="to" class="label required">To</label>
                                            </div>
                                            <div class="field-body">
                                                <div class="field">
                                                    <p class="control is-expanded has-icons-left">
                                                        <input type="text" class="input" id="to" @focus=" checkCompleted " @blur=" checkCompleted "
                                                               v-model="to" placeholder="Who is this for? Name, nickname, etc." required>
                                                        <span class="icon is-left"><i class="fas fa-user"></i></span>
                                                    </p>
                                                    <p class="help">NOTE: This is the name that will appear on the gift card as the recipient.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="field is-horizontal">
                                            <div class="field-label">
                                                <label for="email" class="label required">Email To</label>
                                            </div>
                                            <div class="field-body">
                                                <div class="field">
                                                    <p class="control is-expanded has-icons-left">
                                                        <email type="text" class="input" name="email" id="email" @focus=" checkCompleted " @blur=" checkCompleted "
                                                               v-model="email" placeholder="Recipient's Email Address" required></email>
                                                        <span class="icon is-left"><i class="fas fa-envelope-open"></i></span>
                                                    </p>
                                                    <p class="help">NOTE: This is the email that the gift cards will be sent to!</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="field is-horizontal">
                                            <div class="field-label">
                                                <label for="message" class="label">Message (optional)</label>
                                            </div>
                                            <div class="field-body">
                                                <div class="field">
                                                    <p class="control is-expanded">
                                                        <textarea class="textarea" v-model="message" maxlength="250" id="message" @focus=" checkCompleted " @blur=" checkCompleted " placeholder="(optional) Include a message with the gift card." rows="5"></textarea>
                                                    </p>
                                                    <p class="help has-text-right">Characters Remaining: {{ 250 - message.length }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="is-divider"></div>

                            </template>

                            <template v-if=" digitalOrPhysical === 'physical' ">
                                <div class="card my-3">
                                    <div class="card-header">
                                        <label :for="'code_inner_'+_uid" class="card-header-title">Gift Card Code</label>
                                    </div>
                                    <div class="card-content">
                                        <div class="field">
                                            <div class="control has-icons-left">
                                                <xero-input name="code" v-model="code" class="input" :id="'code_inner_'+_uid" :uppercase="true" />
                                                <span class="icon is-small is-left"><i class="fas fa-tag"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <div class="card">
                                <div class="card-header">
                                    <p class="card-header-title">Your Information</p>
                                </div>
                                <div class="card-content">
                                    <div class="field is-horizontal">
                                        <div class="field-label">
                                            <label for="user_name" class="label required">Name</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <p class="control is-expanded has-icons-left">
                                                    <input type="text" class="input" id="user_name" @focus=" checkCompleted "
                                                           v-model="user_name" placeholder="Card Holder Name" required>
                                                    <span class="icon is-left"><i class="fas fa-user"></i></span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field is-horizontal">
                                        <div class="field-label">
                                            <label for="user_email" class="label required">Email</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <p class="control is-expanded has-icons-left">
                                                    <email type="text" class="input" id="user_email" @focus=" checkCompleted "
                                                           v-model="user_email" name="user_email" placeholder="Card Holder Email" required></email>
                                                    <span class="icon is-left"><i class="fas fa-envelope-open"></i></span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="is-divider"></div>


                            <div>
                                <div class="mb-2">
                                    <label class="xero-checkbox"> Email this gift card to the recipient?
                                        <xero-checkbox
                                            value="1"
                                            name="email_gift_card"
                                            :checked="!!email_gift_card"
                                            @change="(data) => {email_gift_card = !!data;} "
                                        ></xero-checkbox>
                                        <span></span>
                                    </label>
                                </div>
                            </div>

                            <div class="has-text-right" style="margin-bottom:80px;">
                                <button class="button is-primary" type="button" @click.prevent=" submitGiftCardFilling ">Proceed
                                    to Checkout &nbsp;<i class="fas fa-arrow-right"></i></button>
                            </div>


                        </div>


                        <div class="column is-two-thirds" v-if=" step >= 1 ">

                            <div class="card">
                                <div class="card-header">
                                    <p class="card-header-title">Review & Place Order</p>
                                </div>
                                <div class="card-content">

                                    <p><span class="has-text-weight-bold">From</span>: {{ from }}</p>
                                    <p><span class="has-text-weight-bold">To</span>: {{ to }}</p>
                                    <p><span class="has-text-weight-bold">Recipient Email</span>: {{ email }}</p>
                                    <p><span class="has-text-weight-bold">Message</span>: {{ message }}</p>
                                    <br>

                                    <div class="has-text-centered">
                                        <button type="button" @click.prevent=" step-- " class="button is-warning">
                                            Edit Gift Card Details
                                        </button>
                                    </div>

                                    <div class="is-divider"></div>

                                    <div>

                                        <payment-form
                                            :route-use-wallet=" routeUseWallet "
                                            :default-payment-method=" xDefaultPaymentMethod "
                                            :account-balance=" xAccountBalance "
                                            :payment-methods=" xPaymentMethods "
                                            :route-setup-payment=" routeSetupPayment "
                                            :route-process-payment=" routeProcessPayment "
                                            :route-setup-new-card=" routeSetupNewCard "
                                            :stripe-key=" stripeKey "
                                            :order=" order "
                                            :slug=" xUser.slug "
                                            :guest=" !!xUser.guest "
                                            :step=" step "
                                            @step="(s) => {step = s;}"
                                            @order="(o) => {xOrder = o;}"
                                        ></payment-form>

                                    </div>

                                </div>
                            </div>

                        </div>


                        <div v-if=" !kioskMode " class="column is-one-third is-hidden-mobile">


                            <div class="card">
                                <div class="card-header">
                                    <p class="card-header-title"><i class="fas fa-shopping-cart"></i> &nbsp; Order Summary</p>
                                </div>
                                <div class="card-content">
                                    <ul>
                                        <li class="level is-mobile">
                                            <p class="level-left can-shrink">
                                                <span v-if=" quantity > 1 ">$ {{ chosenSize }} Gift Cards x {{ quantity }}</span>
                                                <span v-else>$ {{ chosenSize }} Gift Card</span>
                                            </p>
                                            <p class="level-right">
                                                <span class="has-text-weight-bold" >$ {{ orderTotal() }}</span>
                                            </p>
                                        </li>
                                    </ul>


                                    <template v-if=" !$isEmptyObject(xDiscountCodes) ">
                                        <div class="level is-mobile has-margins-05 has-margins-tb is-padded-05 is-padded-tb has-top-border has-no-bottom-margin has-no-bottom-margin">
                                            <p class="level-left">
                                                <span class="has-text-weight-bold level is-mobile has-margins-05 has-margins-tb is-padded-05 is-padded-tb">Sub-Total:</span>
                                            </p>
                                            <p class="level-right">
                                                <span class="has-text-weight-bold">{{ orderTotal() }}</span>
                                            </p>

                                        </div>

                                        <div class="level is-mobile">
                                            <p class="level-left">
                                                <span class="has-text-weight-bold">Discounts:</span>
                                            </p>
                                            <p class="level-right">
                                                <span class="has-text-weight-bold has-text-success">- $ {{ totalDiscounts }}</span>
                                            </p>
                                        </div>
                                    </template>

                                    <div class="level is-mobile has-margins-05 has-margins-tb is-padded-05 is-padded-tb has-top-border">
                                        <p class="level-left">
                                            <span class="has-text-weight-bold">Order Total:</span>
                                        </p>

                                        <p class="level-right">
                                            <span class="has-text-weight-bold">{{ (finalOrderTotal() === 0 ? 'Free' : '$ ' + finalOrderTotal()) }}</span>
                                        </p>
                                    </div>


                                </div>
                            </div>


                            <div v-if="step === 1 && order.undiscounted_amount > 0 " class="card mt-4">
                                <div class="card-header">
                                    <p class="card-header-title"><i class="fas fa-tags"></i> &nbsp; Discount Code</p>
                                </div>
                                <div class="card-content">

                                    <discount-code
                                        @loading="(data) => {loading = data;}"
                                        @discount-codes="(discountCodes) => {xDiscountCodes = discountCodes}"
                                        @order="(o) => {order = o}"
                                        :existing-discounts =" xDiscountCodes "
                                        :route-add="routeAddDiscountCodes"
                                        :route-remove="routeRemoveDiscountCodes"
                                        :order-id="order.id"
                                    ></discount-code>

                                </div>
                            </div>

                        </div>


                    </div>

                </div>
            </modal>

            <div class="xerocraft-loading" v-if=" loading ">
                <div>
                    <p>
                        <img :src=" $store.state.assetRoute + '/images/loading.gif' " alt="Loading Icon">
                    </p>
                </div>
            </div>
            <div class="xerocraft-success" v-if=" finalSuccess ">
                <section>
                    <div class="level">
                        <div class="level-item">
                            <div :class=" successAnimation ? ' load-complete circle-loader' : 'circle-loader' ">
                                <div :class=" successAnimation ? 'checkmark draw' : 'checkmark draw is-hidden' "></div>
                            </div>
                        </div>
                    </div>
                    <div class="level">
                        <div class="level-item">
                            <h1 class="title has-text-success is-1 has-text-centered" v-html="finalMessage"></h1>
                        </div>
                    </div>
                </section>
            </div>

        </div>
    </div>

</template>

<script>
    import {QrcodeStream} from 'vue-qrcode-reader';

    export default {
        name: 'Gift-Card-Store',
        props: {
            routeInlineLogin: {
                type: String,
                required: true
            },
            routeGuestSetup: {
                type: String,
                required: true
            },
            routeOrderSetup: {
                type: String,
                required: true
            },
            routeGiftCardFilling: {
                type: String,
                required: true
            },
            routeAddDiscountCodes: {
                type: String,
                required: true
            },
            routeRemoveDiscountCodes: {
                type: String,
                required: true
            },
            routeSetupPayment: {
                type: String,
                required: true
            },
            routeProcessPayment: {
                type: String,
                required: true
            },
            routeSetupNewCard: {
                type: String,
                required: true
            },
            sizes: {
                type: Array,
                required: true
            },
            showCustom: {
                type: Boolean,
                required: true
            },
            defaultPaymentMethod: {
                required: false,
            },
            accountBalance: {
                type: Number,
                required: false,
                default: 0
            },
            routeUseWallet: {
                type: String,
                required: false,
                default: ''
            },
            paymentMethods: {
                type: Array,
                required: false,
            },
            stripeKey: {
                type: String,
                required: true
            },
            kioskMode: {
                type: Boolean,
                required: false,
                default: false
            },
            type: {
                type: String,
                required: false,
                default: 'both',
                validator: function (value) {
                    return ['both', 'digital', 'physical'].indexOf(value) !== -1
                }
            }
        },
        data() {
            return {
                loading: false,
                progress: 30,

                digitalOrPhysical: 'digital',
                from: '',
                to: '',
                email: '',
                message: '',
                chosenSize: 0,
                quantity: 1,
                user_name: '',
                user_email: '',
                code: '',
                codeFromQr: '',
                codeSuccess: false,

                step: 0,
                order: {},
                xUser: {},
                xDefaultPaymentMethod: {},
                xAccountBalance: 0,
                xPaymentMethods: [],
                xDiscountCodes: {},

                email_gift_card: false,

                finalMessage: '',
                finalSuccess: false,
                successAnimation: false,
                finished: false
            };
        },
        watch: {
            code: function (val) {
                if(this.codeFromQr) {
                    if(this.code === this.codeFromQr) {
                        this.codeSuccess = true;
                        return;
                    }
                }
                this.codeSuccess = false;
            }
        },
        computed: {
            totalDiscounts: function () {
                let total = 0;
                this.xDiscountCodes.forEach((code) => {
                    total += Number(code.pivot.savings);
                });
                return Number(total.toFixed(2));
            },
        },
        methods: {
            closeOrder: function () {
                this.user_name = '';
                this.user_email = '';
                this.quantity = 1;
                this.from = '',
                this.to = '',
                this.email = '',
                this.message = '';
                this.chosenSize = 0;
                this.step = 0;

                this.order = {};

                this.$modal.hide('choose-user-modal_' + this._uid);
                this.$modal.hide('gift-card-modal_' + this._uid);
            },
            loggedIn: function(data) {
                this.xUser = data.user;
                this.xDefaultPaymentMethod = data.defaultPaymentMethod;
                this.xAccountBalance = data.accountBalance;
                this.xPaymentMethods = data.paymentMethods;
                this.user_email = this.xUser.email;
                this.user_name = this.xUser.name;
                this.progress = 30;
                this.setupOrder();
            },
            guestCheckout: function(data) {
                this.xUser = data.guest;
                this.user_email = this.xUser.email;
                this.user_name = this.xUser.name;
                this.progress = 30;
                this.setupOrder();
            },
            checkCompleted: function () {
                let complete = 3;

                let total = 0;
                if(this.digitalOrPhysical === 'digital') {
                    total = 11;
                    if (this.to) complete++;
                    if (this.from) complete++;
                    if (this.email) complete++;
                    if (this.message) complete++;
                    if (this.user_name) complete++;
                    if (this.user_email) complete++;
                    if (this.message) complete++;
                    if (this.quantity && this.quantity > 0) complete++;
                } else {
                    total = 6;
                    if (this.user_name) complete++;
                    if (this.user_email) complete++;
                }

                this.progress = complete / total * 95;
            },
            checkGiftCardFillingForm: function () {
                if(this.digitalOrPhysical === 'digital') {
                    return !(!this.to || !this.from || !this.email || !this.quantity || this.quantity <= 0 || !this.user_name || !this.user_email);
                } else if(this.digitalOrPhysical === 'physical') {
                    return !(!this.user_name || !this.user_email || !this.code);
                } else {
                    return false;
                }
            },
            startOrder: function() {
                this.chosenSize = Math.round(Number(this.chosenSize));
                if(this.xUser && !this.$isEmptyObject(this.xUser)) {
                    this.setupOrder();
                }
                this.$modal.show('gift-card-modal_' + this._uid);
            },
            setupOrder: function() {
                this.loading = true;

                this.$http.post(
                    this.$prepareRoute(this.routeOrderSetup, {'-USER-SLUG-': this.xUser.slug}), {
                        digitalOrPhysical: this.digitalOrPhysical,
                        size: this.chosenSize,
                        code: this.code
                    })
                    .then(response => {
                        this.$d('response', response);
                        if (response.data.errors) {
                            this.$store.commit('errors', response.data.errors);
                            this.closeOrder();
                        } else if (response.data.error) {
                            this.$store.commit('error', response.data.error);
                            this.closeOrder();
                        } else if (response.data.success === true) {
                            this.order = response.data.order;
                            this.progress = 30;

                            setTimeout(() => {
                                this.$modal.show('gift-card-modal_' + this._uid);
                            }, 100);
                        } else {
                            this.closeOrder();
                            this.$store.commit('error', response.data.message);
                        }
                        this.loading = false;
                    })
                    .catch(error => {
                        this.closeOrder();
                        this.$displayError(error);
                        this.loading = false;
                    });
            },
            submitGiftCardFilling: function () {
                let message;
                if ((message = this.checkGiftCardFillingForm()) !== true) {
                    this.$store.commit('error', message || 'Please fill out all the required information!');
                    return;
                }

                this.loading = true;

                this.$http.post(this.$prepareRoute(this.routeGiftCardFilling, {'-USER-SLUG-': this.xUser.slug, '-ORDER-REF-': this.order.reference}), {
                    to: this.to,
                    from: this.from,
                    email: this.email,
                    message: this.message,
                    quantity: this.quantity,
                    size: this.chosenSize,
                    user_name: this.user_name,
                    user_email: this.user_email,
                    digitalOrPhysical: this.digitalOrPhysical,
                    email_gift_card: this.email_gift_card,
                    code: this.code,
                    _method: 'PATCH'
                })
                    .then(response => {
                        this.$d('response');
                        this.$d(response);
                        if (response.data.hasErrors) {
                            this.$store.commit('errors', response.data.errors);
                        } else if (response.data.success === true && response.data.order) {
                            this.order = response.data.order;
                            this.xDiscountCodes = response.data.order.discount_codes;
                            this.step = 1;
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        } else {
                            this.$store.commit('error', response.data.message);
                        }

                        this.loading = false;
                    })
                    .catch(error => {
                        this.$displayError(error);
                        this.loading = false;
                    });
            },
            orderTotal: function () {
                return this.step > 0 ? (this.order.undiscounted_amount || 0) : this.quantity * this.chosenSize;
            },
            finalOrderTotal: function () {
                let orderAmount = this.orderTotal();
                if(this.$isEmptyObject(this.xDiscountCodes)) {
                    return Number(Number(orderAmount).toFixed(2));
                } else {
                    return Number(Number(orderAmount - this.totalDiscounts).toFixed(2));
                }
            },
            onQRDecode: function (code) {
                if (code) {
                    this.code = code;
                    this.codeFromQr = code;
                    this.$modal.hide('qr-code-reader');
                    this.codeSuccess = true;
                }
            },
        },
        mounted() {
            if(this.$store.state.userLoggedIn && !this.kioskMode) {
                this.user_name = this.$store.state.user.name || '';
                this.user_email = this.$store.state.user.email || '';
                this.xUser = this.$store.state.user;
                this.xDefaultPaymentMethod = this.defaultPaymentMethod;
                this.xAccountBalance = this.accountBalance;
                this.xPaymentMethods = this.paymentMethods;
            }

            if(this.type !== 'physical') this.digitalOrPhysical = 'digital';

            this.loading = false;
            this.checkCompleted();
        },
        components: {
            QrcodeStream
        }
    }
</script>


<style scoped lang="scss">

    @use "sass:math";

    .gift-card-wrapper {
        max-width: 600px;

        & .is-hidden-mobile .card-image {
            border: 8px solid;
        }
        & .is-hidden-tablet {
            border-bottom-left-radius: initial;
            border-bottom-right-radius: initial;

            & .card-image {
                border: 5px solid;
            }
        }
    }

    .gift-card-inner {
        border-bottom: 1px dashed grey;
    }

    .gift-card-bottom {
        border-top: 1px solid lightgray;
    }

    .gift-card-inner-wrapper {
        margin-left: 3rem;;
        margin-right: 3rem;
    }
    @media screen and (max-width: 768px) {
        .gift-card-inner-wrapper {
            margin-left: 0;
            margin-right: 0;
        }
    }

    .xerocraft-success {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(255,255,255, 0.9);
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
        z-index: 1999;

        & section {
            display: inline-block;
            margin: 0 auto;
        }
    }

    // Define vars we'll be using
    $brand-success: #5cb85c;
    $loader-size: 8em;
    $check-height: math.div($loader-size,2);
    $check-width: math.div($check-height,2);
    $check-left: (math.div($loader-size,6) + math.div($loader-size,12));
    $check-thickness: 5px;
    $check-color: $brand-success;

    .circle-loader {
        margin-bottom: math.div($loader-size,2);
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-left-color: $check-color;
        animation: loader-spin 1.2s infinite linear;
        position: relative;
        display: inline-block;
        vertical-align: top;
        border-radius: 50%;
        width: $loader-size;
        height: $loader-size;
    }

    .load-complete {
        -webkit-animation: none;
        animation: none;
        border-color: $check-color;
        transition: border 500ms ease-out;
    }

    .checkmark {

        &.draw:after {
            animation-duration: 800ms;
            animation-timing-function: ease;
            animation-name: checkmark;
            transform: scaleX(-1) rotate(135deg);
        }

        &:after {
            opacity: 1;
            height: $check-height;
            width: $check-width;
            transform-origin: left top;
            border-right: $check-thickness solid $check-color;
            border-top: $check-thickness solid $check-color;
            content: '';
            left: $check-left;
            top: $check-height;
            position: absolute;
        }
    }

    @keyframes loader-spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes checkmark {
        0% {
            height: 0;
            width: 0;
            opacity: 1;
        }
        20% {
            height: 0;
            width: $check-width;
            opacity: 1;
        }
        40% {
            height: $check-height;
            width: $check-width;
            opacity: 1;
        }
        100% {
            height: $check-height;
            width: $check-width;
            opacity: 1;
        }
    }

    textarea.textarea::placeholder {
        color: #b5b5b5;
    }

    .digitalOrPhysicalButton {
        outline: none;
        border: none;
        padding: 2em 0;
        font-size: 2em;
        text-align: center;
        background: #626262;
        font-weight: bold;
        color: #a1a1a1;
        cursor: pointer;
        transition-duration: .3s;
        transition-property: background-color,border-color,color;
        transition-timing-function: ease;

        &:hover {
            background: #6c6c6c;
            color: #f38135;

            & p {
                color: #f38135;
            }
        }
        &:active {
            background: #7f7f7f;
        }

        & p {
            font-size: 0.5em;
            font-weight: normal;
        }

        &.selected {
            background: #4a4a4a;
            color: #f38135;

            & p {
                color: whitesmoke;
            }
        }
    }
    @media screen and (max-width: 768px) {
        .digitalOrPhysicalButton {
            font-size: 1.5em;
        }
    }



</style>
